import * as React from "react";
import { Crop, AspectRatio } from "core/models";
import $ from "./styles.module.scss";

interface Props {
    aspectRatio: AspectRatio;
    trimArea: (trim: Crop) => void;
}

const ResizeArea: React.FC<Props> = ({ aspectRatio, trimArea }) => {
    const containerRef = React.createRef<HTMLDivElement>();
    const [trim, setTrim] = React.useState<Crop>(new Crop());

    const setNewAspectRatio = React.useCallback(
        (newAspectRatio: AspectRatio) => {
            const containerEl = containerRef.current;
            if (!containerEl) {
                return;
            }
            const newTrim = { ...trim };
            newTrim.size.height = containerEl.offsetHeight;

            switch (newAspectRatio) {
                case "1:1":
                    newTrim.size.width = containerEl.offsetHeight;
                    break;
                case "4:5":
                    newTrim.size.width = Math.ceil(
                        (containerEl.offsetHeight / 5) * 4,
                    );
                    break;
                case "9:16":
                    newTrim.size.width = Math.ceil(
                        (containerEl.offsetHeight / 16) * 9,
                    );
                    break;
                case "1:2":
                    newTrim.size.width = Math.ceil(
                        containerEl.offsetHeight / 2,
                    );
                    break;
                case "2:3":
                    newTrim.size.width = Math.ceil(
                        (containerEl.offsetHeight / 3) * 2,
                    );
                    break;
                case "2:1":
                    newTrim.size.height = Math.ceil(
                        containerEl.offsetWidth / 2,
                    );
                    newTrim.size.width = containerEl.offsetWidth;
                    break;
                case "16:9":
                    newTrim.size.height = containerEl.offsetHeight;
                    newTrim.size.width = containerEl.offsetWidth;
                    break;
                default:
                    throw new Error("this should not happen");
            }
            newTrim.outputSize.width = newTrim.size.width;
            newTrim.outputSize.height = newTrim.size.height;
            trim.outputSize.height = containerEl.offsetHeight;
            newTrim.point.x =
                containerEl.offsetWidth / 2 -
                Math.floor(newTrim.size.width / 2);
            newTrim.point = {
                x: Math.floor(
                    containerEl.offsetWidth / 2 - trim.size.width / 2,
                ),
                y: 0,
            };
            setTrim(newTrim);
            trimArea(trim);
        },
        [containerRef, trim, trimArea],
    );

    React.useEffect(() => {
        setNewAspectRatio(aspectRatio);
    }, [aspectRatio]);

    const blockStyles = {
        top: `${trim.point.y}px`,
        left: `${trim.point.x}px`,
        width: `${trim.size.width}px`,
        height: `${trim.size.height}px`,
    };
    return (
        <div ref={containerRef} className={$.resize__container}>
            <div style={blockStyles} className={$.resize__block} />
        </div>
    );
};

export default ResizeArea;
